export const getScheduleDateFormat = (projectState) => {
  const scheduleDateFormat = projectState.allSectors.find(
    (schedule) => schedule.id === projectState.sectorSelected
  );

  return scheduleDateFormat && scheduleDateFormat.dateFormat
    ? scheduleDateFormat.dateFormat
    : 'DD/MM/YYYY';
};
